import { Directive, HostListener, Input, inject } from '@angular/core';
import { ServiceUpgradeInjectorService } from '../service-upgrade-injector.service';
import { Router } from '@angular/router';

@Directive({
	selector: '[ng-ui-sref]',
	standalone: true,
})
export class NgUiSrefDirective {
	private router = inject(Router);
	private ServiceUpgradeInjectorService = inject(ServiceUpgradeInjectorService);

	@Input('ng-ui-sref') ngUiSref: string | { state: string; params?: Record<string, any> } = '';

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		this.navigate();
	}

		/* TODO
	----
	not fully backwards compatible, can accept string
	or an object argument { state: 'visitDetail', params: { id: order.id } }
	but cant parse visitDetail({id: visit.id})
	this function needs expanding if you want to
	backward-compatible the ui-sref to accept arguments.
	HINT:some sort of regex mixed with json parsing should get you there
	----
	 */
	public parseUiSrefString(uiSrefString: string): { state: string; params?: Record<string, any> } {
		// Regex to extract the state name and params object as string
		const regex = /^(\w+)\((\{.*\})\)$/;
		const match = uiSrefString.match(regex);

		if (match) {
			const state = match[1];
			let params = {};

			try {
				// Replace single quotes with double quotes only in the params section for JSON compatibility
				const paramsString = match[2].replace(/(\w+)\s*:/g, '"$1":').replace(/'/g, '"');
				params = JSON.parse(paramsString);
			} catch (error) {
				console.error('Failed to parse parameters in ui-sref string:', error);
			}

			return { state, params };
		}

		// If format is invalid, return as a simple state with no params
		return { state: uiSrefString, params: {} };
	}

	navigate() {
		// Check if ngUiSref is a string that needs parsing or an already formatted object
		const { state, params } =
			typeof this.ngUiSref === 'string'
				? this.parseUiSrefString(this.ngUiSref)
				: this.ngUiSref;

		// Ensure params is defined as an empty object if undefined
		this.ServiceUpgradeInjectorService.getAngularJsUiState().go(state, params || {});
	}
}

